import {action, observable, makeObservable} from "mobx";

export class TopicSwitcherStore {
    visible: boolean;
    constructor() {
        makeObservable(this, {
            visible: observable,
            setVisible: action
        });
        this.setVisible(false);
    }
    setVisible(visible: boolean) {
        this.visible = visible;
    }
}
